import gql from 'graphql-tag';

export const PEOPLE_EMPLOYEE_DOCUMENT_ASSIGNMENT_FRAGMENT = gql`
	fragment peopleEmployeeDocumentAssignment on EmployeeDocumentAssignment {
		id
		stage
		cadence
		cycleKey
		dueAt
		status
		waivedAt
		resolvedAt
		employee {
			id
			firstName
			lastName
			preferredName
		}
		requirement {
			id
			cadence
			stage
		}
		documentType {
			id
			name
			settings
		}
	}
`;

export const GET_EMPLOYEE_DOCUMENT_ASSIGNMENTS = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: EmployeeDocumentAssignmentFilter
	) {
		getEmployeeDocumentAssignments(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...peopleEmployeeDocumentAssignment
			}
			count
		}
	}
	${PEOPLE_EMPLOYEE_DOCUMENT_ASSIGNMENT_FRAGMENT}
`;

export const WAIVE_EMPLOYEE_DOCUMENT_ASSIGNMENT = gql`
	mutation waiveEmployeeDocumentAssignment($id: ID!) {
		waiveEmployeeDocumentAssignment(id: $id) {
			...peopleEmployeeDocumentAssignment
		}
	}
	${PEOPLE_EMPLOYEE_DOCUMENT_ASSIGNMENT_FRAGMENT}
`;

export const UNWAIVE_EMPLOYEE_DOCUMENT_ASSIGNMENT = gql`
	mutation unwaiveEmployeeDocumentAssignment($id: ID!) {
		unwaiveEmployeeDocumentAssignment(id: $id) {
			...peopleEmployeeDocumentAssignment
		}
	}
	${PEOPLE_EMPLOYEE_DOCUMENT_ASSIGNMENT_FRAGMENT}
`;

export const REQUEST_EMPLOYEE_DOCUMENT_UPLOAD = gql`
	mutation requestEmployeeDocumentUpload($id: ID!) {
		requestEmployeeDocumentUpload(id: $id) {
			...peopleEmployeeDocumentAssignment
		}
	}
	${PEOPLE_EMPLOYEE_DOCUMENT_ASSIGNMENT_FRAGMENT}
`;

export const REQUEST_EMPLOYEE_DOCUMENT_RECORD_REDO = gql`
	mutation requestEmployeeDocumentRecordRedo($id: ID!, $dueAt: Date) {
		requestEmployeeDocumentRecordRedo(id: $id, dueAt: $dueAt) {
			...peopleEmployeeDocumentAssignment
		}
	}
	${PEOPLE_EMPLOYEE_DOCUMENT_ASSIGNMENT_FRAGMENT}
`;
